import { useState } from "react";

export const useAPIendpointsFormState = () => {
  const [formData, setFormData] = useState({
    apiRegistryId: null,
    environmentId: null,
    endpointUrl: "",
    protocolId: null,
    wsdlUrl: "",
    graphqlSchemaLocation: "",
    openapiSpecUrl: "",
    webhookUrl: "",
    operationsConfig: "",

    authTypeId: null,
    clientId: "",
    clientSecret: "",
    tokenUrl: "",

    timeoutMs: "",
    maxRequests: "",
    perMilliseconds: "",
    maxRetries: "",
    backoffStrategy: "",

    isActive: true,

    /* =====================
       FIELD STATUS
    ====================== */
    apiRegistryIdStatus: "unchecked",
    environmentIdStatus: "unchecked",
    endpointUrlStatus: "unchecked",
    protocolIdStatus: "unchecked",
    wsdlUrlStatus: "unchecked",
    graphqlSchemaLocationStatus: "unchecked",
    openapiSpecUrlStatus: "unchecked",
    webhookUrlStatus: "unchecked",
    operationsConfigStatus: "unchecked",

    authTypeIdStatus: "unchecked",
    clientIdStatus: "unchecked",
    clientSecretStatus: "unchecked",
    tokenUrlStatus: "unchecked",

    timeoutMsStatus: "unchecked",
    maxRequestsStatus: "unchecked",
    perMillisecondsStatus: "unchecked",
    maxRetriesStatus: "unchecked",
    backoffStrategyStatus: "unchecked",
  });

  const handleChange = (event, selectEvent) => {
    let state = { ...formData };

    /* =====================
       SELECT HANDLING
    ====================== */
    if (!event?.target && selectEvent) {
      state[selectEvent.name] = event;
      state[`${selectEvent.name}Status`] = event?.value
        ? "success"
        : "unchecked";
      setFormData(state);
      return;
    }

    /* =====================
       INPUT HANDLING
    ====================== */
    const { name, value, type, checked } = event.target;

    switch (name) {
      case "endpointUrl":
      case "wsdlUrl":
      case "graphqlSchemaLocation":
      case "openapiSpecUrl":
      case "webhookUrl":
      case "tokenUrl":
        state[`${name}Status`] = /^https?:\/\//.test(value)
          ? "success"
          : value
          ? "error"
          : "unchecked";
        break;

      case "clientId":
      case "clientSecret":
        state[`${name}Status`] =
          value.length >= 3 ? "success" : value ? "error" : "unchecked";
        break;

      case "timeoutMs":
      case "maxRequests":
      case "perMilliseconds":
      case "maxRetries":
        state[`${name}Status`] =
          Number(value) > 0 ? "success" : value ? "error" : "unchecked";
        break;

      case "jsonSchema": {
        if (!value.trim()) {
          state.operationsConfigStatus = "unchecked";
        } else {
          try {
            JSON.parse(value);
            state.operationsConfigStatus = "success";
          } catch {
            state.operationsConfigStatus = "error";
          }
        }
        break;
      }

      case "backoffStrategy":
        state.backoffStrategyStatus = value ? "success" : "unchecked";
        break;

      default:
        break;
    }

    state[name] = type === "checkbox" ? checked : value;
    setFormData(state);
  };

  const checkAllFields = () =>
    formData.apiRegistryIdStatus === "success" &&
    formData.environmentIdStatus === "success" &&
    formData.endpointUrlStatus === "success" &&
    formData.protocolIdStatus === "success" &&
    formData.authTypeIdStatus === "success" &&
    formData.timeoutMsStatus === "success";

  return {
    formData,
    setFormData,
    handleChange,
    checkAllFields,
  };
};
